export enum ChatbotRoutes {
  root = 'chatbot',
  all = 'all',
  texting = 'texting',
  calling = 'calling',
  new = 'new',
  edit = 'edit',
  analytic = 'analytic',
  steps = 'steps',
  view = 'view',
}
